import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgX = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Close",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Union",
			d: "M8.00313 6.15096C7.53194 5.67977 6.76799 5.67977 6.2968 6.15096C5.82561 6.62215 5.82561 7.3861 6.2968 7.85729L11.1314 12.6919L6.2968 17.5265C5.82561 17.9977 5.82561 18.7616 6.2968 19.2328C6.76799 19.704 7.53194 19.704 8.00313 19.2328L12.8377 14.3982L17.6723 19.2328C18.1435 19.704 18.9075 19.704 19.3787 19.2328C19.8499 18.7616 19.8499 17.9977 19.3787 17.5265L14.5441 12.6919L19.3787 7.85729C19.8499 7.3861 19.8499 6.62215 19.3787 6.15096C18.9075 5.67977 18.1435 5.67977 17.6723 6.15096L12.8377 10.9856L8.00313 6.15096Z",
			fill: "white"
		})
	})
});
const ForwardRef = forwardRef(SvgX);
export default ForwardRef;
